import { object, ref, string } from 'yup';
import { specialCharacters } from '@lon/shared/constants';
import { SYSTEM_CODE_NUMBERS } from './types';

export const getValidation = () => {
  const validationSchema = object({
    newPassword: string()
      .required('New Password is a required field.')
      .matches(/^(?!.* )/, 'Should not contain spaces')
      .min(16, 'Password must be at least 16 characters.')
      .matches(/\d+/, 'Should contain at least one digit')
      .matches(/[a-z]+/, 'Should contain at least one lower case')
      .matches(
        /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/,
        'Should contain at least one special character'
      )
      .matches(/[A-Z]+/, 'Should contain at least one upper case')
      .default(''),
    confirmPassword: string()
      .required('Repeat password.')
      .oneOf([ref('newPassword'), null], 'Passwords must match.')
      .default(''),
  });

  return {
    validationSchema,
    defaultValues: validationSchema.cast({}),
  };
};

export const validateNewPassword = (newPassword: string | undefined) => {
  const result: SYSTEM_CODE_NUMBERS[] = [];

  if (!newPassword?.match(/^(?!.* )/)) {
    result.push('1');
  }
  if (!newPassword?.match(/^.{16,}$/)) {
    result.push('8');
  }
  if (!newPassword?.match(/\d+/)) {
    result.push('3');
  }
  if (!newPassword?.match(/[A-Z]+/)) {
    result.push('4');
  }
  if (!newPassword?.match(/[a-z]+/)) {
    result.push('5');
  }
  if (!newPassword?.match(specialCharacters)) {
    result.push('9');
  }
  return result;
};
